export const getVisibleColumns = (columns) =>
    columns.reduce((filtered, col) => {
      if (
        col.options === undefined ||
        col.options.display === undefined ||
        col.options.display === true ||
        col.options.display === 'true'
      ) {
        filtered.push(col.name);
      }
      return filtered;
    }, []);
  